import React from "react";
import { useNavigate } from "react-router-dom";
import { X, ArrowRight, PartyPopper, Target, Rocket, Star, GraduationCap, Users, School, Building2, Ticket, Sprout, Store, Dumbbell, Briefcase } from "lucide-react";
import { programs } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";

const ICONS = { PartyPopper, Target, Rocket, Star, GraduationCap, Users, School, Building2, Ticket, Sprout, Store, Dumbbell, Briefcase };

export default function RouteModal({ open, onClose }) {
  const navigate = useNavigate();
  const { u } = useLang();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full md:max-w-3xl bg-cream rounded-t-[28px] md:rounded-[28px] shadow-2xl max-h-[88vh] overflow-hidden animate-sheet">
        <div className="hidden md:flex justify-center pt-3">
          <span className="h-1.5 w-12 rounded-full bg-black/15" />
        </div>
        <div className="flex items-start justify-between px-7 md:px-10 pt-6 md:pt-4">
          <div>
            <p className="text-xs font-extrabold tracking-[0.25em] text-[#B99B2E]">{u.modal.programsKicker}</p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A1C30] mt-1">{u.modal.chooseRoute}</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-black/5 transition-colors">
            <X className="w-6 h-6 text-[#0A1C30]" />
          </button>
        </div>

        <div className="supera-scroll overflow-y-auto px-5 md:px-8 py-5 space-y-2.5" style={{ maxHeight: "calc(88vh - 120px)" }}>
          {programs.map((p) => {
            const Icon = ICONS[p.icon];
            return (
              <button
                key={p.id}
                onClick={() => { onClose(); navigate(`/registro/${p.id}`); }}
                className="group w-full flex items-center gap-4 bg-white rounded-2xl px-4 py-3.5 shadow-sm ring-1 ring-black/5 hover:ring-[var(--gold)] hover:shadow-md transition-all"
              >
                <span className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: p.bg }}>
                  <Icon className="w-6 h-6" style={{ color: p.color }} />
                </span>
                <span className="flex-1 text-left">
                  <span className="block font-extrabold text-[#0A1C30] leading-tight">{p.name}</span>
                  <span className="block text-sm text-[#6B7688]">{p.age}</span>
                </span>
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#FBF0CE] flex items-center justify-center group-hover:bg-[var(--gold)] transition-colors">
                  <ArrowRight className="w-4 h-4 text-[#0A1C30]" />
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
